// src/api/axiosConfig.js
import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  withCredentials: true,
});

// Interceptor to attach token, but skip for login/register
api.interceptors.request.use((config) => {
  const isAuthRoute = config.url.includes('/login') || config.url.includes('/register');
  if (!isAuthRoute) {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

export default api;
